exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".full-image{background:#792293;background-size:cover;background-repeat:no-repeat;width:100%;height:100vh;position:relative}.full-image:before{content:\"\";width:100%;height:100vh;position:absolute;background:rgba(0,0,0,.5);top:0;left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b875b69","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/page/widgets/FullSizeImageWidget.vue
// module id = 72
// module chunks = 0 1 2